import React from "react";
import { cn, STATUS_LABELS, STATUS_TONES, PRIORITY_TONES, TONE_CLASSES, timeAgo } from "../lib/utils";
import { useStatuses } from "../context/StatusContext";

export function StatusBadge({ status, className }) {
  const { byKey } = useStatuses();
  const def = byKey[status];
  const tone = def?.tone ? TONE_CLASSES[def.tone] : STATUS_TONES[status];
  const label = def?.label || STATUS_LABELS[status] || (status || "").replace(/_/g, " ");
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border",
        tone || "bg-slate-100 text-slate-700 border-slate-200",
        className
      )}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70 mr-1.5" />
      {label}
    </span>
  );
}

export function PriorityBadge({ priority, className }) {
  return (
    <span
      data-testid={`priority-badge-${priority}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border capitalize",
        PRIORITY_TONES[priority] || "bg-slate-100 text-slate-700 border-slate-200",
        className
      )}
    >
      {priority}
    </span>
  );
}

export function ClientRepliedBadge({ at, className }) {
  if (!at) return null;
  return (
    <span
      data-testid="client-replied-badge"
      title={`Client replied ${timeAgo(at)}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide",
        "bg-amber-100 text-amber-700 border border-amber-200",
        className
      )}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70 mr-1.5" />
      Client replied · {timeAgo(at)}
    </span>
  );
}
